<template>
  <div class="flex flex-col">
    <div
      v-if="isWalletConnected"
      class="bg-PRIMARY rounded-md p-4 flex flex-row items-center justify-between w-full"
    >
      <div class="flex flex-row gap-3 items-center">
        <div class="bg-LIGHTGREY rounded-md w-10 h-10"></div>
        <div class="flex flex-col justify-between items-start gap-2">
          <p class="font-semibold text-sm">POW Wallet</p>
          <p class="text-GREY text-xs">ID : 12321422112</p>
        </div>
      </div>
      <div
        @click="openConnectWalletDrawer"
        class="flex flex-col items-center justify-center text-xs cursor-pointer underline"
      >
        Change Wallet
      </div>
    </div>
    <div v-else class="bg-PRIMARY rounded-lg p-4 flex flex-col items-start">
      <div class="bg-LIGHTGREY rounded-md w-6 h-6"></div>
      <p class="font-semibold pt-4 text-start">You Haven't Connected Your Wallet</p>
      <p class="font-sm text-GREY pt-3 text-start">
        Link your wallet now to unlock features and start earning rewards!
      </p>
      <pow-button @click="openConnectWalletDrawer" green size="lg" class="mt-5 !text-[14px]"
        >Connect Wallet</pow-button
      >
    </div>

    <p class="text-lg font-semibold pt-6 text-start">Swap Tokens</p>
    <p class="text-GREY text-xs pt-1 text-start">
      Swap token will be change Coin POW To your NFT Coin the one you choose.
    </p>

    <div class="flex flex-col items-start gap-4 border border-1 border-GREY rounded-lg p-3 mt-4">
      <div class="flex flex-row justify-between w-full">
        <p class="text-GREY text-sm font-semibold">You Send</p>
        <div class="flex flex-row gap-2 items-center">
          <img src="../assets/icons/token-2.svg" class="w-5 h-5 object-contain" />
          <div @click="openSendTokenDrawer" class="text-GREY font-semibold text-sm">
            {{ selectedSendToken.name }}
          </div>
          <font-awesome-icon class="w-4 h-4 object-contain" icon="fa-solid fa-angle-down" />
        </div>
      </div>

      <input
        v-model="sendAmount"
        @input="formatAmount"
        class="placeholder-WHITE bg-transparent border-0 focus:outline-none text-2xl font-semibold w-full"
      />
    </div>

    <font-awesome-icon class="rotate-90 py-4" icon="fa-solid fa-arrow-right-arrow-left" />

    <div class="flex flex-col items-start gap-4 border border-1 border-GREY rounded-lg p-3">
      <div class="flex flex-row justify-between w-full">
        <p class="text-GREY text-sm font-semibold">You Receive</p>
        <div class="flex flex-row gap-2 items-center">
          <img src="../assets/icons/token-2.svg" class="w-5 h-5 object-contain" />
          <div @click="openRecriveTokenDrawer" class="text-GREY font-semibold text-sm">
            {{ selectedReceiveToken.name }}
          </div>
          <font-awesome-icon class="w-4 h-4 object-contain" icon="fa-solid fa-angle-down" />
        </div>
      </div>
      <p class="text-2xl font-semibold">0.00</p>
    </div>

    <pow-button @click="openWithDrawDrawer(history[0])" size="xs" v-if="isWalletConnected" class="mt-5" secondary>
      <p class="text-sm">Withdraw</p></pow-button
    >
    <pow-button size="xs" v-else class="mt-5" secondary>
      <p class="text-sm">Connect Wallet</p></pow-button
    >

    <p v-if="!isWalletConnected" class="text-GREY text-start pt-1">* Need to connect wallet</p>
    <div class="flex flex-col pt-4">
      <div class="flex flex-col items-start gap-3">
        <p class="font-semibold text-sm">Swap History</p>
        <div class="rounded-lg bg-WHITE flex flex-row p-3 gap-3 items-center w-full">
          <font-awesome-icon class="black-icon" icon="fa-solid fa-magnifying-glass" />
          <input
            v-model="searchInput"
            placeholder="Search History"
            class="placeholder-[##8B8B8B] bg-WHITE border-0 focus:outline-none text-sm text-BLACK w-full"
          />
        </div>
        <div class="flex flex-col gap-2 w-full">
          <div
            v-if="history[0]"
            v-for="withdraw in history"
            @click="openWithDrawInfoDrawer(withdraw)"
            class="bg-PRIMARY rounded-md py-3 px-4 flex flex-col gap-2 w-full"
          >
            <div class="flex flex-row gap-2 items-center">
              <div class="bg-LIGHTGREY rounded-md w-5 h-5 me-1"></div>
              <p class="text-sm font-medium">{{ withdraw.wallet }}</p>
              <div
                class="flex flex-col justify-center bg-WHITE rounded-full items-center w-1 h-1"
              ></div>
              <p class="text-sm font-medium">ID : {{ withdraw.id }}</p>
            </div>
            <div></div>
            <div class="flex flex-col gap-2 items-center w-full">
              <div class="flex flex-row justify-between items-center w-full">
                <div class="flex flex-row gap-2 items-center">
                  <p class="text-sm">{{ withdraw.sendToken }}</p>
                  <font-awesome-icon icon="fa-solid fa-arrow-right" />
                  <p class="text-sm">{{ withdraw.recriveToken }}</p>
                </div>
                <p class="text-sm font-medium">
                  {{ withdraw.sendToken }} {{ withdraw.sendAmount }}
                </p>
              </div>
              <div class="flex flex-row justify-between items-center w-full">
                <p class="text-xs text-GREY">{{ withdraw.date }}</p>
                <p class="text-xs text-GREY">
                  {{ withdraw.recriveToken }} {{ withdraw.recriveAmount }}
                </p>
              </div>
            </div>
          </div>

          <div v-else class="flex flex-row justify-center items-center w-full pt-3">
            <div class="flex flex-col gap-5 items-center justify-center">
              <div class="flex flex-col justify-center items-center p-7 rounded-full bg-[#E8EBF7]">
                <font-awesome-icon
                  size="md"
                  class="black-icon"
                  icon="fa-solid fa-clock-rotate-left"
                />
              </div>
              <p class="text-sm">History Empty</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import PowButton from '@/components/PowButton.vue'
import TokenDrawer from '@/components/drawers/TokenDrawer.vue'
import ConnectWalletDrawer from '@/components/drawers/ConnectWalletDrawer.vue'
import WithdrawDrawer from '@/components/drawers/WithdrawDrawer.vue'
import WithdrawInfoDrawer from '@/components/drawers/WithdrawInfoDrawer.vue'


const isWalletConnected = ref(true)
const sendAmount = ref((0.0).toFixed(2))
const searchInput = ref('')

const formatAmount = () => {
  if (!isNaN(sendAmount.value)) {
    sendAmount.value = parseFloat(sendAmount.value).toFixed(2)
  }
}

const tokens = ref([
  {
    name: 'POW Token',
    selected: true,
    rate: '0.01'
  },
  {
    name: 'ETH',
    selected: false,
    rate: '30.00'
  },
  {
    name: 'BTC',
    selected: false,
    rate: '20.00'
  }
])

const history = ref([
  {
    wallet: 'POW Wallet',
    id: '13216549841',
    sendToken: 'POW Token',
    recriveToken: 'USDT',
    sendAmount: '123.232',
    recriveAmount: '95.00',
    date: '12 August, 2024',
    time: '08:00 AM',
    content: 'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    wallet: 'POW Wallet',
    id: '21654656455',
    sendToken: 'USD',
    recriveToken: 'POW Token',
    sendAmount: '25.00',
    recriveAmount: '80.156',
    date: '10 September, 2024',
    time: '08:00 AM',
    content: 'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  },
  {
    wallet: 'POW Wallet',
    id: '231564965',
    sendToken: 'POW Token',
    recriveToken: 'USDT',
    sendAmount: '123.232',
    recriveAmount: '95.00',
    date: '12 August, 2024',
    time: '08:00 AM',
    content: 'Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.'
  }
])

const openWithDrawDrawer = (withDrawInfo) => {
  openBottomDrawer(WithdrawDrawer, {
    props: {withdrawInfo: withDrawInfo},
    emits: {},
    size: 'md'
  })
}
const openWithDrawInfoDrawer = (withDrawInfo) => {
  openBottomDrawer(WithdrawInfoDrawer, {
    props: {withdrawInfo: withDrawInfo},
    emits: {},
    size: 'sm'
  })
}
const selectedSendToken = ref(tokens.value[0])
const selectedReceiveToken = ref(tokens.value[0])

const setSelectedRecvive = (token) => {
  console.log(token)
  selectedReceiveToken.value = token
}

const setSelectedSend = (token) => {
  console.log(token)
  selectedSendToken.value = token
}

const openConnectWalletDrawer = () => {
  openBottomDrawer(ConnectWalletDrawer, {
    props: {},
    emits: {},
    size: 'sm'
  })
}

const openRecriveTokenDrawer = () => {
  openBottomDrawer(TokenDrawer, {
    props: { tokens: tokens.value },
    backgroundColor: 'bg-white',
    xmarkColor: 'arrow_icon_color',
    emits: { selected: setSelectedRecvive },
    size: 'md'
  })
}

const openSendTokenDrawer = () => {
  openBottomDrawer(TokenDrawer, {
    props: { tokens: tokens.value },
    backgroundColor: 'bg-white',
    xmarkColor: 'arrow_icon_color',
    emits: { selected: setSelectedSend },
    size: 'md'
  })
}
</script>
